import React from 'react';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';
import { twMerge } from 'tailwind-merge';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';

interface Props {
    primaryText: string;
    secondaryText?: string | number;
    handleNavigate: () => void;
    iconKey?: IconKey;
}

const InfoItem = ({
    primaryText,
    secondaryText,
    handleNavigate,
    iconKey = 'chevron_right',
}: Props) => {
    const dispatch = useAppDispatch();
    const onClick = () => {
        if (handleNavigate) {
            handleNavigate();
        }
        dispatch(
            segmentTrack(TICKET_STRINGS.CLICK_GO_TO_ADD_MEMBERS, {
                component: 'ticket details overview',
            }),
        );
    };

    return (
        <div className="flex flex-col">
            <div
                className={twMerge(
                    'flex h-10 items-center justify-between bg-transparent px-2 py-0 text-xs text-gray-800',
                    handleNavigate
                        ? 'cursor-pointer hover:rounded-sm hover:bg-gray-200'
                        : '',
                )}
                onClick={onClick}
            >
                <div className="flex w-full justify-between">
                    <span className="flex items-center text-base">
                        {primaryText}
                    </span>
                    {secondaryText ? (
                        <span className="flex items-center pe-2">
                            {secondaryText}
                        </span>
                    ) : null}
                </div>
                {handleNavigate ? (
                    <Icon
                        iconKey={iconKey}
                        // Only the chevron points somewhere, so only it mirrors in RTL
                        className={twMerge(
                            iconKey === 'chevron_right' && 'rtl:scale-x-[-1]',
                        )}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default React.memo(InfoItem);
